import { Swiper, Navigation, Pagination, EffectFade } from 'swiper/core';
Swiper.use([Navigation, Pagination, EffectFade]);

export default () => {

  const m = {}
  const init = () => {
    m.root = document.getElementById('modal');
    if (!m.root) {
      return;
    }
    console.log('init modal seat');

    const targetSeats = ['general', 'box', 'premium', 'vip'];
    m.targetContents = [].filter.call(m.root.querySelectorAll('.c-modal__details-item'), content => {
      return targetSeats.includes(content.dataset.content);
    })
    if (m.targetContents.length == 0) {
      return
    }

    buildSwipers();
  }

  const buildSwipers = () => {
    m.root.classList.add('is-visibled', 'is-behind');
    m.swipers = [];
    m.targetContents.forEach(content => {
      buildSwiper(content);
    });
    m.root.classList.remove('is-visibled', 'is-behind');
  }
  const buildSwiper = (contentRoot) => {
    contentRoot.classList.add('is-visibled');
    const container = contentRoot.querySelector('.ti-modal-seat__container');
    const pagination = contentRoot.querySelector('.ti-modal-seat__pagination');
    const prevBtn = contentRoot.querySelector('.ti-modal-seat__btn._prev');
    const nextBtn = contentRoot.querySelector('.ti-modal-seat__btn._next');

    const swiperOption = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: pagination,
        type: 'fraction',
        currentClass: 'ti-modal-seat__pagination-current',
        totalClass: 'ti-modal-seat__pagination-total',
        formatFractionCurrent: (number) => {
          return ('0' + number).slice(-2);
        }
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      }
    }

    contentRoot.swiperObj = new Swiper(container, swiperOption);
    m.swipers.push(contentRoot.swiperObj);
    // contentRoot.classList.remove('is-visibled');
  }

  init();
}
